import { UserInfo } from '../types/auth.types';

const TOKEN_KEY = 'auth_token';
const USER_INFO_KEY = 'user_info';

export const AuthUtils = {
  // Token management
  setToken: (token: string): void => {
    localStorage.setItem(TOKEN_KEY, token);
  },

  getToken: (): string | null => {
    return localStorage.getItem(TOKEN_KEY);
  },

  removeToken: (): void => {
    localStorage.removeItem(TOKEN_KEY);
  },

  // User info management
  setUserInfo: (userInfo: UserInfo): void => {
    localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
  },

  getUserInfo: (): UserInfo | null => {
    const userInfo = localStorage.getItem(USER_INFO_KEY);
    if (!userInfo || userInfo === 'undefined') {
      return null;
    }
    try {
      return JSON.parse(userInfo);
    } catch (error) {
      console.error('Failed to parse user info:', error);
      return null;
    }
  },

  removeUserInfo: (): void => {
    localStorage.removeItem(USER_INFO_KEY);
  },

  // Check if user is logged in
  isLoggedIn: (): boolean => {
    const token = AuthUtils.getToken();
    return !!token;
  },

  // Clear all auth data
  clearAuth: (): void => {
    AuthUtils.removeToken();
    AuthUtils.removeUserInfo();
  },

  // Initialize auth on login
  initializeAuth: (token: string, userInfo: UserInfo): void => {
    AuthUtils.setToken(token);
    AuthUtils.setUserInfo(userInfo);
    
  },
};

